"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const withFlags_1 = __importDefault(require("./withFlags"));
const RequiresFlag = ({ children, hasFlag, flag }) => {
    if (hasFlag(flag)) {
        return children;
    }
    return null;
};
exports.default = (0, withFlags_1.default)(RequiresFlag);
